import React, { Component } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { typography } from "./utils/typography";
import { Dashboard } from "./components/dashboard";
import { MapAnalysis } from "./components/mapAnalysis";
import { Mapping } from "./components/map";

import Loader from "react-loader-spinner";
// import { DatarequestForm } from "./components/datarequestForm";
// import { Welcome } from "./welcome";
import { Grid } from "react-flexbox-grid";
import { css } from "glamor";
import glamorous from "glamorous";

import "./custom.css";

export default function App() {
  const style = css({
    background: "white",
  });
  const Box = glamorous.div({
    background: "white",
    margin: "3rem",
  });
  const load = css({
    marginLeft: "auto",
    marginRight: "auto",
    paddingTop: "8rem",
  });
  return (
      <>
          <Router>
              <div {...style}>
                  <Box>
                      <Route exact path="/investment" component={Dashboard} />
                      <Route exact path="/mapanalysis" component={Mapping} />
                        {/* <Route exact path="/requestdata" component={DatarequestForm} /> */}
                  </Box>
              </div>
          </Router>
      </>
  );
}
